// Task 24 — product-sticky-bar ("satc"): shows after the main add-to-cart button scrolls out of
// view, mirrors image/price/compare/qty from the active bundle, and hands the actual add-to-cart
// off to the main product form. Behaviour adapted from
// source/export/02-matrix-colagen/18-product-sticky-cart/section.js (same visibility threshold,
// qty stepper and price-sync ideas), but rewired onto the real Task 16 contract (product.js,
// committed — read theme/assets/product.js:265-335, function setActive) instead of the export's
// own globals/DOM polling:
//   - export polled `.dl-qb-row.is-active` / `.dl-qb-card.is-active` in the DOM for the active
//     bundle; product.js instead dispatches `dl:bundle-changed` on `document` with
//     `detail = { qty, total, was, perUnit, title, row, section }` (money in cents) — we just
//     listen. `title` is the bundle TIER label ("Tratament 40 de zile"), not the product title —
//     the live sticky markup has no secondary line for it (checked matrix--09-satc-84.html,
//     ulei--10-satc-69.html and dom/matrix/63-style.html), so it's read but intentionally never
//     written anywhere. There is no `image` field today; an `image` URL may be added to the
//     payload later, so it's read defensively (only applied when it's a non-empty string) but its
//     absence is expected and harmless.
//   - export called the Fetch API directly against its own cart endpoints on click; this bar
//     never calls any such endpoint — the CTA re-syncs the real qty input and clicks the real
//     add-to-cart button ([data-dl-atc]), so Releasit (or the theme's own AJAX handler) takes over
//     exactly as if the shopper had clicked it themselves.
//   - export's `window._dlNextAllowedQty` / `window._dlQbCardsForQty` hooks (bundle-aware stepping)
//     don't exist on this contract, but product.js's own [data-dl-qty] `change` listener does the
//     equivalent tier-snapping and re-dispatches `dl:bundle-changed` — so whenever a main
//     [data-dl-qty] exists on the page, this bar's stepper does NOT compute its own price at all;
//     it only pushes the requested qty to [data-dl-qty] and lets that cascade (product.js snaps
//     the tier, re-dispatches the event, onBundleChanged below updates price/compare/discount,
//     including re-syncing this very qty display to the snapped value). The plain
//     basePrice × qty fallback only runs when there is no main [data-dl-qty] on the page at all
//     (e.g. an isolated render) — same idea as export's own fallback branch when its bundle hooks
//     were absent.
(function () {
  'use strict';

  function initStickyBar(root) {
    root.querySelectorAll('[data-dl-sticky-bar]:not([data-bound])').forEach(bindStickyBar);
  }

  function bindStickyBar(bar) {
    bar.dataset.bound = '1';
    // Oprit pentru desktop ȘI mobil (schema settings) — Liquid a randat deja `hidden`, dar nu
    // pornim niciun observer/listener nici dacă atributul e scos manual ulterior.
    if (bar.hidden) return;

    var teardown = []; // fiecare listener/observer pornit aici — oprit integral la unload
    function on(el, evt, handler, opts) {
      el.addEventListener(evt, handler, opts);
      teardown.push(function () { el.removeEventListener(evt, handler, opts); });
    }

    var threshold = parseInt(bar.dataset.showAfter, 10) || 600;
    var basePrice = parseInt(bar.dataset.basePrice, 10) || 0; // cenți

    function show() { bar.classList.add('sticky-cart-visible'); }
    function hide() { bar.classList.remove('sticky-cart-visible'); }
    // „Ascuns" = fără cutie de layout (display:none pe el sau pe un părinte) ori visibility:hidden.
    function isHidden(el) {
      if (!el) return false;
      if (el.offsetParent === null) return true;
      var cs = window.getComputedStyle ? window.getComputedStyle(el) : null;
      return !!cs && (cs.display === 'none' || cs.visibility === 'hidden');
    }

    var atcBtn = document.querySelector('[data-dl-atc]');
    // Releasit COD ascunde butonul propriu al temei (display:none) și pune formularul lui inline.
    // Dacă butonul EXISTĂ dar n-are cutie de layout, bara asta n-are ce face și ar strica două
    // lucruri deodată:
    //   • IntersectionObserver pe un element fără cutie nu raportează niciodată isIntersecting,
    //     deci ramura `else show()` s-ar declanșa la prima notificare și bara ar rămâne veșnic pe
    //     ecran;
    //   • CTA-ul ei ar da `.click()` pe un submit ascuns — DL.bindAtcForms se retrage când detectează
    //     Releasit, deci browserul ar face un POST simplu spre /cart/add și ar naviga la /cart,
    //     ocolind complet formularul de ramburs (adică fluxul real de comenzi).
    // Deci: rămâne ascunsă și nu leagă nimic.
    if (atcBtn && isHidden(atcBtn)) { bar.hidden = true; hide(); return; }
    if (atcBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hide(); else show();
        });
      }, { threshold: 0 });
      io.observe(atcBtn);
      teardown.push(function () { io.disconnect(); });
    } else {
      // Fallback: nu există [data-dl-atc] pe pagină (ex. randare izolată) sau IO nespus — după
      // show_after_scroll px derulați, ca pe live/export (data-threshold).
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          if (window.scrollY > threshold) show(); else hide();
          ticking = false;
        });
      };
      on(window, 'scroll', onScroll, { passive: true });
      onScroll();
    }

    // ---- cantitate + preț -------------------------------------------------------------------
    var qtyInput = bar.querySelector('[data-scb-qty-input]');
    var minusBtn = bar.querySelector('[data-qty-minus]');
    var plusBtn = bar.querySelector('[data-qty-plus]');
    var priceEl = bar.querySelector('[data-scb-price]');
    var compareEl = bar.querySelector('[data-scb-compare]');
    var discEl = bar.querySelector('[data-scb-disc]');
    var imageEl = bar.querySelector('[data-scb-image]');
    var mainQtyInput = document.querySelector('[data-dl-qty]');

    function fmtMoney(cents) {
      return window.DL && typeof window.DL.money === 'function' ? window.DL.money(cents) : String(Math.round(cents) / 100);
    }
    function getQty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      return n > 0 ? n : 1;
    }
    function pushQtyToMainForm(qty) {
      if (!mainQtyInput) return;
      mainQtyInput.value = qty;
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // Fallback FĂRĂ [data-dl-qty] pe pagină (randare izolată): nimic altceva recalculează prețul
    // pentru noi, așa că facem aproximarea basePrice × cantitate, la fel ca fallback-ul din export
    // când lipseau hook-urile lui de pachete.
    function applyLocalQtyFallback(qty) {
      if (qtyInput) qtyInput.value = qty;
      if (priceEl && basePrice) priceEl.textContent = fmtMoney(basePrice * qty);
      if (compareEl) compareEl.hidden = true;
      if (discEl) discEl.hidden = true;
    }
    // Cât timp [data-dl-qty] există, stepperul de-aici NU calculează nimic — doar cere cantitatea
    // formularului principal; product.js (funcția setActive) potrivește cantitatea pe treapta cea
    // mai apropiată și re-emite `dl:bundle-changed`, care e ce actualizează efectiv preț/comparație
    // /discount aici (onBundleChanged, mai jos) — inclusiv resincronizarea acestui input, dacă
    // treapta aleasă are altă cantitate decât cea cerută.
    function setLocalQty(qty) {
      if (qtyInput) qtyInput.value = qty;
      if (mainQtyInput) pushQtyToMainForm(qty);
      else applyLocalQtyFallback(qty);
    }
    if (minusBtn && qtyInput) on(minusBtn, 'click', function () { setLocalQty(Math.max(1, getQty() - 1)); });
    if (plusBtn && qtyInput) on(plusBtn, 'click', function () { setLocalQty(getQty() + 1); });
    if (qtyInput) on(qtyInput, 'change', function () { setLocalQty(getQty()); });

    // Sincronizare din pachetul activ (product.js, Task 16) — actualizează preț/comparație/discount
    // /cantitate/imagine afișate aici; NU rescrie [data-dl-qty] (bundle selector-ul și-a actualizat
    // deja propriul câmp de cantitate, nu avem de ce să pornim un du-te-vino). `detail.title` e
    // eticheta TREPTEI de pachet ("Tratament 40 de zile"), nu titlul produsului — markup-ul live nu
    // are un rând secundar pentru ea, așa că e ignorată intenționat (nescrisă nicăieri).
    // `detail.image` nu există încă în contractul curent al lui product.js — dacă apare mai
    // târziu, se aplică doar când e un string nevid; altfel imaginea principală a produsului
    // (randată de Liquid) rămâne neschimbată.
    function onBundleChanged(e) {
      var d = (e && e.detail) || {};
      if (typeof d.qty === 'number' && qtyInput) qtyInput.value = d.qty;
      if (typeof d.total === 'number' && priceEl) priceEl.textContent = fmtMoney(d.total);
      var hasCompare = typeof d.was === 'number' && typeof d.total === 'number' && d.was > d.total;
      if (compareEl) {
        if (hasCompare) { compareEl.textContent = fmtMoney(d.was); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (discEl) {
        if (hasCompare) {
          var pct = Math.round((d.was - d.total) / d.was * 100);
          discEl.textContent = '−' + pct + '%';
          discEl.hidden = false;
        } else discEl.hidden = true;
      }
      if (imageEl && typeof d.image === 'string' && d.image) {
        imageEl.src = d.image;
        imageEl.removeAttribute('srcset');
      }
    }
    on(document, 'dl:bundle-changed', onBundleChanged);

    // ---- CTA: nu adaugă nimic direct — sincronizează cantitatea și lasă formularul principal
    // (Releasit sau handler-ul AJAX al temei) să proceseze adăugarea în coș. ----------------------
    var cta = bar.querySelector('[data-sticky-add]');
    if (cta) {
      on(cta, 'click', function () {
        pushQtyToMainForm(getQty());
        var liveAtcBtn = document.querySelector('[data-dl-atc]');
        // A doua verificare, la click: Releasit poate ascunde butonul DUPĂ pornirea paginii.
        // Nu apăsăm niciodată un submit ascuns — ar ocoli formularul de ramburs.
        if (!liveAtcBtn || isHidden(liveAtcBtn)) return;
        liveAtcBtn.click();
      });
    }

    bar._dlStickyCleanup = function () {
      teardown.forEach(function (fn) { fn(); });
      teardown.length = 0;
      bar._dlStickyCleanup = null;
      delete bar.dataset.bound;
    };
  }

  document.addEventListener('shopify:section:unload', function (e) {
    var target = e.target;
    if (!target) return;
    if (target.matches && target.matches('[data-dl-sticky-bar]') && typeof target._dlStickyCleanup === 'function') {
      target._dlStickyCleanup();
    }
    if (target.querySelectorAll) {
      target.querySelectorAll('[data-dl-sticky-bar]').forEach(function (bar) {
        if (typeof bar._dlStickyCleanup === 'function') bar._dlStickyCleanup();
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initStickyBar(document);
    if (window.DL && typeof window.DL.use === 'function') window.DL.use(initStickyBar);
  });
})();
